<template>
  <div>
    <form class="form-horizontal">
      <input type="hidden" name="id" id="id"/>

      <div class="form-group lp-flex-box" style='align:left'>
          <label class="control-label col-sm-3">名称</label>
          <div class="controls col-sm-8">
              <input type="text" name="name" id="name" v-model="biz.name" class="form-control" />
          </div>
          <span class="help-inline">必填</span>
      </div>
      <div class="form-group lp-flex-box" style='align:left'>
          <label class="control-label col-sm-3">权限</label>
          <div class="controls col-sm-8">
              <input type="text" name="permission" id="permission" v-model="biz.permission" class="form-control input-sm" />
          </div>
          <span class="help-inline">必填</span> 
      </div>
      
      <div class="form-group lp-flex-box" style='align:left'>
        <button class="btn" type="button" @click="close">取消</button>
        <button class="btn green" type="button" @click="save">确定</button>
      </div>

    </form>
  </div>
</template>

<script>
import http from '../../lib/utils/request.js'
import commonMethods from '../../lib/methods/common.js'
import mixins from '../../mixins/index'
import {MSG_ID, SER_RESP_CODE} from '../../lib/constant.js'
export default {
  name: 'roleedit',
  mixins: mixins,
  data () {
    return {
      biz: {
        name: '',
        id: '',
        permission: '',
        groupId: 1,
        applicationId: 1
      }
    }
  },
  methods: {
    load () {
      if (this.biz.id) {
        this.loadPermission()
      }
    },
    loadPermission () {
      if (this.biz.id) {
        http.invoke('auth.pagePermission', {account: this.uid(), id: this.biz.id}, (data) => {
          let permission = data.content && data.content[0]
          if (permission) {
            this.biz.id = permission.id
            this.biz.name = permission.name
            this.biz.permission = permission.permission
          }
        })
      }
    },
    onShowInModal (...args) {
      let options = args[0]
      this.biz.id = +options['id']
      this.load()
    },
    onHideInModal (...args) {
      this.biz.id = 0
      this.biz.name = ''
      this.biz.permission = ''
    },
    close () {
      window.emitter.emit(MSG_ID.MSG_UI_HIDE_MODAL)
    },
    save () {
      if (!this.biz.name || !this.biz.permission) {
        window.emitter.emit(MSG_ID.MSG_UI_TIP_WARN, '信息不完整')
        return
      }
      let reqdata = {action: 1, id: this.biz.id, name: this.biz.name, permission: this.biz.permission, group_id: this.biz.groupId, application_id: this.biz.applicationId}
      http.invoke('auth.setPermission', reqdata, (data) => {
        window.emitter.emit(MSG_ID.MSG_UI_HIDE_MODAL)
        window.emitter.emit(MSG_ID.MSG_UI_TIP_SUCC, '保存成功!')
        window.emitter.emit(MSG_ID.MSG_PERMISSION_SET_SUCCESS)
      }, (state) => {
        if (state.code !== 2000000) {
          window.emitter.emit(MSG_ID.MSG_UI_TOAST_ERR, SER_RESP_CODE[state.code])
          return
        }
      })
    },
    ...commonMethods
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: #42b983;
}
@media screen and (max-width: 767px) {
  .mh {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// PermissionEdit.vue?6c30ca52